<div class="tab-list">
	<!-- <select name="reportList" [(ngModel)]="selectedReport" (ngModelChange)="onSelectReport()">
		<option *ngFor="let report of reportList" [ngValue]="report">{{report.label}}</option>
	</select> -->
	<div *ngFor="let report of reportList" class="tab-list-item" [ngClass]="{'selected-item': selectedReport===report}" (click)="onSelectReport(report)">{{selectedReportType === 'ALL' ? report.type + ': ' : ''}}{{report.label}}</div>

</div>